/**
 * Created by commyfeng on 2017/3/21.
 */
var RequestErrorType = {
  NETWORK_ERR: 'NETWORK_ERR',
  SYSTEM_ERR: 'SYSTEM_ERR',
  LOGIC_ERR: 'LOGIC_ERR',
  PROCCESSED_ERR: 'PROCCESSED_ERR'
};
export default RequestErrorType;